export const prices = [
    {
        name: "Підпашки",
        price: "40zł"
    },
    {
        name: "Вусики",
        price: "20zł"
    },
    {
        name: "Бікіні (глибоке)",
        price: "100zł"
    },
    {
        name: "Бікіні (класичне)",
        price: "60zł"
    },
    {
        name: "Ноги (повністю)",
        price: "110zł"
    },
    {
        name: "Ноги (до колін)",
        price: "70zł"
    },
    {
        name: "Стегна",
        price: "80zł"
    },
    {
        name: "Руки (повністью)",
        price: "70zł"
    },
    {
        name: "Руки (до ліктя)",
        price: "55zł"
    },
];

export const pricesKit = [
    {
        name: ["Підпашки","Бікіні глибоке", "Ноги (повністю)"],
        price: "225zł"
    },
    {
        name: ["Підпашки","Бікіні (глибоке)"],
        price: "125zł"
    },
    {
        name: ["Підпашки", "Руки (повністю)", "Ноги (повністю)"],
        price: "200zł"
    },
    {
        name: ["Бікіні глибоке", "Руки (повністю)", "Ноги (повністю)"],
        price: "255zł"
    },
];